import script from "./NewFind.vue?vue&type=script&setup=true&lang=js"
export * from "./NewFind.vue?vue&type=script&setup=true&lang=js"

import "./NewFind.vue?vue&type=style&index=0&id=171504df&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-171504df"]])

export default __exports__